import { useEffect } from "react";

import Briefcase01 from "@uui/Briefcase01";
import Building07 from "@uui/Building07";
import User01 from "@uui/User01";
import { noop } from "lodash/fp";

import { Box, Stack, Typography } from "@mui/material";

import PlanChip from "@app/analytics/components/PlanChip";
import UpsellTooltipWrapper from "@app/analytics/components/UpsellTooltipWrapper";
import useRollupContext from "@app/analytics/hooks/meetops/useRollupContext";
import useWorkspace from "@app/common/workspaces/useWorkspace";

import FilterDropdown from "./FilterDropdown";
import RollupFilterIcon from "./RollupFilterIcon";

const LOADING = { id: "LOADING", label: "Loading..." };
const SELECT_TEAM = { id: "SELECT_TEAM", label: "Select a team" };

/**
 * Placeholder rollup filter when a user is on the free plan and their
 * trial has expired
 */
const RollupFilterFree = () => {
  const { reset: resetRollupFilters, usersFilter } = useRollupContext();
  const { inWorkspace, workspace, workspaceLoading } = useWorkspace();

  useEffect(() => {
    resetRollupFilters();
  }, []);

  if (!inWorkspace) return null;

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      justifyContent="space-between"
      sx={{
        width: "100%",
        bgcolor: "shades.ghost.300",
        p: 2,
        overflowX: "auto",
      }}
      spacing={2}
    >
      <Stack direction="row" spacing={2}>
        <Stack direction="row" alignItems="center" sx={{ mx: 2 }}>
          <RollupFilterIcon icon={Building07} />
          <Typography variant="bodySecondaryMed">
            {workspace.name || "Loading..."}
          </Typography>
        </Stack>
        <Box sx={{ position: "relative" }}>
          <UpsellTooltipWrapper show>
            <>
              <FilterDropdown
                id="teams-filter"
                options={[SELECT_TEAM]}
                selected={SELECT_TEAM}
                onChange={noop}
                icon={Briefcase01}
                disabled
              />
              <PlanChip
                label="Pro"
                sx={{ position: "absolute", right: "8px", top: "8px" }}
              />
            </>
          </UpsellTooltipWrapper>
        </Box>
        <FilterDropdown
          id="users-filter"
          options={[usersFilter]}
          selected={workspaceLoading ? LOADING : usersFilter}
          onChange={noop}
          icon={User01}
        />
      </Stack>
    </Stack>
  );
};

export default RollupFilterFree;
